import { Injectable } from '@angular/core';
import { Login } from './login.model';
import { GeneralHttpService } from 'src/app/shared/general-http.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private readonly url = "Login";
  constructor(private generalHttp: GeneralHttpService) { }

  postLogin(data: Login) {
    return this.generalHttp.postWithoutToken(data, this.url);
  }

  logOut() {
    return this.generalHttp.getHttp("Login/LogOut");
  }


  dt(data:any){
    return this.generalHttp.postHttp(data,`${this.url}/dt`);
  }
  
  validateIsWeCump(idUser:number) {
    return this.generalHttp.getHttp(`${this.url}/ValidateIsOnlyWeCumplimiento/${idUser}`);
  }

  getCaptcha() {
    return this.generalHttp.getHttp("Login/getCaptcha");
  }
}



